import React from "react";
import { Logo } from "./Logo";

import "./Logo.scss";

export type FeedLogoProps = {
  cx?: string;
};

export const FeedLogo: React.FC<FeedLogoProps> = ({ cx = "" }) => {
  return (
    <div
      className={`Logo ${cx}`}
      style={{ display: "flex", alignItems: "center" }}
    >
      <Logo cx={cx} />
      <svg
        width="169"
        height="32"
        viewBox="0 0 169 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={"feed"}
        style={{ transform: "translateX(-149px)" }}
      >
        <path d="M125.561 7.046c.276 0 .647.017 1.036.086V5.638a7.564 7.564 0 0 0-1.382-.138c-2.158 0-3.461 1.26-3.461 3.341v1.9h-2.055v1.424h2.055V24h1.666V12.165h2.918V10.74h-2.918V9.17c0-1.425.682-2.124 2.141-2.124zm13.644 10.048c0-4.506-2.771-6.535-5.646-6.535-3.461 0-5.853 2.866-5.853 6.897 0 4.023 2.348 6.82 6.078 6.82 2.684 0 4.566-1.45 5.162-3.28h-1.787c-.466.846-1.545 1.787-3.375 1.787-2.625 0-4.325-1.917-4.403-4.904h9.824v-.785zm-9.815-.665c.146-2.391 1.795-4.376 4.178-4.376 2.322 0 3.945 1.899 3.945 4.376h-8.123zm23.536.665c0-4.506-2.771-6.535-5.646-6.535-3.462 0-5.853 2.866-5.853 6.897 0 4.023 2.348 6.82 6.077 6.82 2.685 0 4.567-1.45 5.163-3.28h-1.787c-.466.846-1.545 1.787-3.376 1.787-2.624 0-4.325-1.917-4.402-4.904h9.824v-.785zm-9.816-.665c.147-2.391 1.796-4.376 4.179-4.376 2.322 0 3.945 1.899 3.945 4.376h-8.124zm17.519 7.847c2.426 0 3.505-1.52 4.049-2.676h.181V24h1.615V6.32h-1.666v6.89h-.13c-.518-1.132-1.58-2.651-4.023-2.651-3.263 0-5.507 2.737-5.507 6.846 0 4.126 2.227 6.871 5.481 6.871zm.225-1.51c-2.598 0-4.023-2.357-4.023-5.387 0-3.004 1.399-5.318 4.023-5.318 2.555 0 3.988 2.184 3.988 5.318 0 3.142-1.459 5.386-3.988 5.386z" />
        <defs>
          <clipPath id="a">
            <path transform="translate(41 8)" d="M0 0h73.28v16H0z" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
